import { render, staticRenderFns } from "./UpdatePlatformSchedulingSQLModal.vue?vue&type=template&id=32b88095&scoped=true&"
import script from "./UpdatePlatformSchedulingSQLModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePlatformSchedulingSQLModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b88095",
  null
  
)

export default component.exports